import { forwardRef } from "react";

import {
  TABLE_CELL_CLASS_NAME,
  type TTDProps,
} from "@/ui/components/data-display/Table/Table.config";
import { cn } from "@/ui/lib/utils";

export const TD = forwardRef<HTMLTableCellElement, TTDProps>(
  (
    {
      className,
      ...props
    },
    ref,
  ) => (
    <td
      {...props}
      ref={ref}
      data-component="TD"
      className={cn(TABLE_CELL_CLASS_NAME, className)}
    />
  ),
);

TD.displayName = "TD";
